import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MyIcon } from "../../common/baseConfig";
import * as actions from './redux/actions';
import { Modal } from 'antd';

export class CountDown extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    time: 0,
    useTime: 0,
  }
  timer = null;
  startTimer = false;

  componentWillReceiveProps(nextProps) {
    const { fetchGetExamDetailSuccess, checkAllPars } = nextProps.quesStore;
    if (checkAllPars) {
      clearInterval(this.timer);
      this.startTimer = false;
      return;
    }
    let Data = fetchGetExamDetailSuccess;

    if (Data) {

      let { PaperInfo } = Data;
      let Time = PaperInfo.Time * 60;
      let _t = this;
      if (!this.startTimer) {
        this.timer = setInterval(() => {
          this.startTimer = true;
          if (Time === 0) {
            clearInterval(this.timer);
            //倒计时结束
            _t.submitPaper();
            return;
          }
          this.setState({
            time: --Time,
            useTime: PaperInfo.Time * 60 - Time,
          })
        }, 1000)
      }
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer);
    this.startTimer = false;
  }
  //提交试卷
  submitPaper() {
    const { fetchGetExamDetailSuccess, } = this.props.quesStore;
    let Data = fetchGetExamDetailSuccess;
    let { PaperInfo, ResultId } = Data;
    this.props.actions.fetchGetExamPageResult({
      busId: PaperInfo.ID,
      resultId: ResultId,
    }).then(res => {
      if (res.SuccessResponse) {
        let params = {};
        let arr = [];
        for (let i = 0; i < res.Data.QuestionType.length; i++) {
          const ele = res.QuestionType.Data[i];
          let { Question } = ele;
          for (let j = 0; j < Question.length; j++) {
            const element = Question[j];
            if (element.MyAnswer) {
              if ([1, 2, 4].indexOf(element.QuestionType_ID) !== -1) {
                //主观题
                if (element.Answer === element.MyAnswer) {
                  arr.push({ ID: element.ID, MyAnswer: element.MyAnswer, Judge: 1, QuestionType_ID: element.QuestionType_ID })
                } else {
                  arr.push({ ID: element.ID, MyAnswer: element.MyAnswer, Judge: 0, QuestionType_ID: element.QuestionType_ID })
                }
              } else {
                //客观题
                arr.push({ ID: element.ID, MyAnswer: element.MyAnswer, Judge: 0, QuestionType_ID: element.QuestionType_ID })
              }
            } else {
              arr.push({ ID: element.ID, MyAnswer: "", Judge: 0, QuestionType_ID: element.QuestionType_ID })
            }
          }
        }
        params = {
          resultId: ResultId,
          list: arr,
        }
        this.props.actions.fetchSubmitPra(params).then(res => {
          if (res.SuccessResponse) {
            Modal.confirm({
              title: "时间到！交卷成功，是否查看解析？",
              okText: "查看解析",
              cancelText: "返回列表",
              onOk: () => {
                //查看所有解析
                this.props.actions.updateCheckAllPars({ payload: true })
              },
              onCancel: () => {
                if (PaperInfo.ExamPaperType === 0) {
                  this.props.history.push('/center/startExer/2');
                } else {
                  this.props.history.push('/center/startExer/1');
                }
              }
            })
          }
        })
      }
    })
  }
  format(time) {
    let h, m, s;
    h = Math.floor(time / (60 * 60));
    m = Math.floor(time % (60 * 60) / 60);
    s = (time % (60 * 60)) % 60;
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    return `${h}:${m}:${s}`;
  }
  render() {
    const { time, useTime } = this.state;
    const { checkAllPars } = this.props.quesStore;
    return (
      <div className="ques-store-count-down">
        <div className="countDown">
          <div className="countDown-left">
            <MyIcon type="iconxuexijilu" className="clock" />
            <span className="tit">{checkAllPars ? "用时:" : "倒计时:"}</span>
            <div className={`exer-count-down time`}>
              <span style={{ fontSize: 16 }}>{this.format(checkAllPars ? useTime : time)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CountDown);



// WEBPACK FOOTER //
// ./src/features/ques-store/CountDown.js